export enum PagerLocation {
    Top = 1,
    Bottom = 2,
    Both = 3,
    None = 4
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-grid/pager-location.model.ts